import SectionHeader from '../common/SectionHeader';

function RoadmapSection({ items }) {
  return (
    <section className="service-section">
      <div className="container">
        <SectionHeader
          eyebrow="Growth Potential"
          title="Roadmap and future potential"
          description="The roadmap highlights practical next layers that can compound the project without changing its core positioning."
        />
        <div className="service-roadmap">
          {items.map((item, index) => (
            <article className="service-roadmap__item" key={item}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <h3>{item}</h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RoadmapSection;
